import { Typography } from "@mui/material";
import { useWallets } from "api/wallets";
import { useAppSelector } from "app/hooks";
import { Subheader } from "components/Header/Subheader/Subheader";
import { SubheaderLinkButton } from "components/Header/Subheader/SubheaderLinkButton";
import { SubheaderWrapper } from "components/Header/Subheader/SubheaderWrapper";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { StatusValue } from "components/Table/StatusValue";
import { useMessage } from "hooks/intl";
import { useParams } from "react-router-dom";
import { selectDefaultLanguageData } from "reduxState/translations/translationsSlice";
import { links } from "utilities/links";
import { WalletDetails } from "./WalletDetails";
import { WalletOverview } from "./WalletOverview";
import { useStyles } from "./styles";

export const SingleWallet = () => {
  const classes = useStyles();
  const { message } = useMessage();
  const { id: walletTypeId } = useParams<{ id: string }>();
  const { useWalletTypeData } = useWallets();
  const defaultLang = useAppSelector(selectDefaultLanguageData);
  const { data: walletTypeDetails } = useWalletTypeData(walletTypeId as string);
  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "typesOfWallets" }),
      path: links.walletTypesList,
    },
  };
  const walletName = walletTypeDetails
    ? walletTypeDetails?.translations?.[defaultLang.code]?.name ||
      walletTypeDetails.code ||
      ""
    : "";

  return (
    <>
      <TopHeader
        title={walletName}
        clearLink={links.walletTypesList}
        breadcrumbs={breadcrumbs}
        data-hj-suppress
        badge={<StatusValue status={!!walletTypeDetails?.active} />}
      />
      <Subheader>
        <SubheaderWrapper alignRight>
          <SubheaderLinkButton
            text={message({ id: "editWallet" })}
            link={links.editWalletType(walletTypeId)}
          />
        </SubheaderWrapper>
      </Subheader>
      <section className={classes.content}>
        <Typography className={classes.sectionTitle}>
          {message({ id: "walletOverview" })}
        </Typography>
        <WalletOverview walletDetails={walletTypeDetails} />
      </section>
      <section className={classes.section}>
        <Typography className={classes.sectionTitle}>
          {message({ id: "walletDetails" })}
        </Typography>
        <WalletDetails walletDetails={walletTypeDetails} />
      </section>
    </>
  );
};
